import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

/**
 * 목록 화면 로딩 모양: 검색 조건(표 + 오른쪽 조회 버튼) / 툴바 / 그리드
 * - newpla(@newpla/ng-lib) 의 bs5-placeholder-list2 를 대신한다. selector 가 같으므로 화면 HTML 은 그대로 쓴다. (NpxCommonModule)
 * - 검색 조건은 화면과 같은 클래스(np-form-table, np-col-set, np-search-actions)로 그려 테마 모양을 따른다.
 */
@Component({
  selector: 'bs5-placeholder-list2',
  templateUrl: './bs5-placeholder-list2.component.html',
  styleUrls: ['./bs5-placeholder-list2.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class Bs5PlaceholderList2Component {

  // 0 이면 검색 조건을 그리지 않는다. 1 이상이면 한 줄만 그린다.
  @Input()
  filterRowCnt: number = 1;

  counter(i: number) {
    return new Array(i);
  }

}
